"use strict";

exports.__esModule = true;
exports.default = void 0;

var _reactEmotion = _interopRequireDefault(require("react-emotion"));

var _base = _interopRequireDefault(require("../../shared/base"));

var _font = _interopRequireDefault(require("../../shared/font"));

var _H = require("./H1");

var _mediaQueries = _interopRequireDefault(require("../../shared/mediaQueries"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Title = /*#__PURE__*/(0, _reactEmotion.default)('h4', {
  target: "e1k65nh90"
})(_base.default, ";", _font.default, ";", _H.text, ";font-size:", function (props) {
  return props.fontSize || '1rem';
}, ";line-height:", function (props) {
  return props.lineHeight || '1.5rem';
}, ";font-weight:", function (props) {
  return props.fontWeight || 'normal';
}, ";", (0, _mediaQueries.default)('md'), "{font-size:0.75rem;line-height:1.065rem;}");
var _default = Title;
exports.default = _default;